// --- src/services/api.js ---
import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // sends httpOnly cookie on every request automatically
  headers: {
    'Content-Type': 'application/json',
  },
});

// FIXED: removed localStorage token interceptor — cookie is sent automatically
// by the browser via withCredentials: true, no manual header injection needed

// FIXED: auto-redirect to login on 401/403 instead of showing broken empty pages
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// ── Monitoring ────────────────────────────────────────────────────────────────
export const monitoringAPI = {
  getServices:       ()            => api.get('/monitoring/services'),
  getServiceDetails: (serviceName) => api.get(`/monitoring/services/${serviceName}`),
  getUptimeHistory:  (days = 7)    => api.get(`/monitoring/uptime-history?days=${days}`),
  getSystemHealth:   ()            => api.get('/monitoring/health'),
};

// ── Plans (public to authenticated users) ────────────────────────────────────
export const plansAPI = {
  getAll:  ()    => api.get('/plans'),
  getById: (id)  => api.get(`/plans/${id}`),
};

// ── Subscriptions (admin only) ────────────────────────────────────────────────
export const subscriptionsAPI = {
  getAll:       (params = {}) => api.get('/admin/subscriptions', { params }),
  getById:      (id)          => api.get(`/admin/subscriptions/${id}`),
  getByCompany: (company_id)  => api.get(`/admin/subscriptions/company/${company_id}`),
  getMRR:       ()            => api.get('/admin/subscriptions/stats/mrr'),
  create:       (data)        => api.post('/admin/subscriptions', data),
  update:       (id, data)    => api.put(`/admin/subscriptions/${id}`, data),
  updateStatus: (id, status)  => api.post(`/admin/subscriptions/${id}/status`, { status }),
};

// ── App deployment (Company Admin) ────────────────────────────────────────────
export const getNamespaces = () => api.get('/company-admin/namespaces');

export const getApps = () => api.get('/company-admin/apps');

export const createApp = ({ appName, namespaceId, githubUsername, appInfo, components }) =>
  api.post('/company-admin/apps', { appName, namespaceId, githubUsername, appInfo, components });

export const getDiskSizes = () => api.get('/company-admin/deployments/disk-sizes');
export const deleteDeployment = (appName) =>
  api.delete(`/company-admin/deployments/${encodeURIComponent(appName)}`);
export const createDeployment = ({ appId, hasPvc, diskSizeGb, image }) =>
  api.post('/company-admin/deployments', { appId, hasPvc, diskSizeGb, image });

export const createSecrets = ({ namespaceId, secretName, secrets, certificate }) =>
  api.post('/company-admin/secrets', { namespaceId, secretName, secrets, certificate });

export default api;
